import React from 'react'
import { useTranslation } from 'react-i18next'
import { shallow } from 'zustand/shallow'

import Box from '@mui/material/Box'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'

import EmpresaTiposPeriodos from './EmpresaTiposPeriodos'
import EmpresaTiposNovedades from './EmpresaTiposNovedades'
import Layout from '../Layout/Layout'

import { useParametrosStore } from '../../store/parametrosStore'
import EmpresaConfigurarNomina from './EmpresaConfigurarNomina'
import { useHasPermissions } from 'react-simple-rbac'

type TabLabelType = {
  id: number
  labelKey: string
  permission?: string
}

const tabsLabels: TabLabelType[] = [
  { id: 1, labelKey: 'tabs.periodTypes' },
  { id: 2, labelKey: 'tabs.noveltyTypes' },
  { id: 3, labelKey: 'tabs.configuration', permission: 'read:company-structures' },
]

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`parametro-tabpanel-${index}`}
      aria-labelledby={`parametro-tab-${index}`}
      style={{ height: '100%' }}
      {...other}
    >
      {/* {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )} */}
      {value === index && children}
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `parametro-tab-${index}`,
    'aria-controls': `parametro-tabpanel-${index}`,
    sx: { color: 'black' },
  }
}

const EmpresaParametros = () => {
  const { t } = useTranslation('empresaParametros')
  const setEmpresaTabValue = useParametrosStore(state => state.setEmpresaTabValue)
  const empresaTabValue = useParametrosStore(state => state.empresaTabValue, shallow)
  const canConfigurePayroll = useHasPermissions(['read:company-structures'])

  // Filtrar tabs según permisos
  const visibleTabs = tabsLabels.filter(
    tab => !tab.permission || (tab.permission === 'read:company-structures' && canConfigurePayroll),
  )

  const handleChangeTab = (newTabValue: number) => {
    setEmpresaTabValue(newTabValue)
  }

  // Si hay lógica para resetear tab, actualizar aquí si es necesario

  const companyId = useParametrosStore(state => state.actualEmpresa)
  return (
    <Layout icon="SettingsIcon" title={`${t('pageTitle')} `} breadcrumb>
      <Box
        sx={{
          height: '100%',
          '& .theme--header': {
            backgroundColor: '#EEF1FC',
          },
        }}
      >
        <Box>
          <Tabs
            value={empresaTabValue}
            onChange={(_, value: number) => handleChangeTab(value)}
            aria-label="parametros tabs"
            TabIndicatorProps={{ sx: { backgroundColor: 'black' } }}
            sx={{ '& button.Mui-selected': { color: 'black' } }}
          >
            {visibleTabs.map((tabLabel, index) => {
              return <Tab key={index} label={t(tabLabel.labelKey)} {...a11yProps(index)} />
            })}
          </Tabs>
        </Box>
        <TabPanel value={empresaTabValue} index={0}>
          <EmpresaTiposPeriodos />
        </TabPanel>
        <TabPanel value={empresaTabValue} index={1}>
          <EmpresaTiposNovedades />
        </TabPanel>
        {canConfigurePayroll && (
          <TabPanel value={empresaTabValue} index={2}>
            <EmpresaConfigurarNomina />
          </TabPanel>
        )}
      </Box>
    </Layout>
  )
}

export default EmpresaParametros
